<template>
  <form id="frm_action">
    <div class="p-formgrid row">
      <div class="col-lg-6">

        <div class="mt-3">
          <label class="txt-right required">Gửi đến</label>
          <Dropdown v-model="selectedRecieverType" :disabled="mode=='edit'" id="reciever_type" :options="reciever_type" optionLabel="label" placeholder="Chọn"/>
          <input class="input_tmp_validator" id="reciever_type_add"/>
        </div>

        <div class="mt-2" v-if="selectedRecieverType && (selectedRecieverType.value == 4)">
          <label class="txt-right required">Trang trại</label>
          <MultiSelect v-model="farm" :disabled="mode=='edit'" :options="farmOptions" :filter="true" :showToggleAll="false" optionLabel="name" placeholder="Chọn">
            <template #value="">
              Chọn
            </template>
          </MultiSelect>

          <div class="mt-2" v-show="farm.length > 0">
            <label v-for="(item, index) in farm" :key="`farm-span-${index}`" class="cus-tags">
              <span class="cs-tag">
                {{item.name}}
              </span>
              <i v-show="mode=='add'" class="fas fa-times cs-icon" v-on:click="removeSpan(index, 'farm')"></i>
            </label>
          </div>
          <input class="input_tmp_validator" id="farm" />
        </div>

        <div class="mt-2" v-if="selectedRecieverType && (selectedRecieverType.value == 3 || (selectedRecieverType.value == 4 && farm.length > 0))">
          <label class="txt-right required">Chọn người</label>
          <MultiSelect v-model="user" :disabled="mode=='edit'" :options="userOptions" :filter="true" :showToggleAll="false" optionLabel="fullname" placeholder="Chọn">
            <template #value="">
              Chọn
            </template>
          </MultiSelect>

          <div class="mt-2" v-show="user.length > 0">
            <label v-for="(item, index) in user" :key="`user-span-${index}`" class="cus-tags">
              <span class="cs-tag">
                {{item.fullname}}
              </span>
              <i v-show="mode=='add'" class="fas fa-times cs-icon" v-on:click="removeSpan(index, 'user')"></i>
            </label>
          </div>
          <input class="input_tmp_validator" id="user" />
        </div>

        <div class="mt-2">
          <label class="txt-right required">Tiêu đề</label>
          <InputText
            v-model="title"
            id="title"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
            :disabled="mode=='edit'"
          />
          <input class="input_tmp_validator" id="title_add" />
        </div>

        <div class="mt-2">
          <label class="txt-right required">Mô tả ngắn</label>
          <Textarea
            v-model="short_content"
            id="short_content"
            :autoResize="true"
            rows="2"
            maxlength="2000"
            class="input-text-box"
            placeholder="Nhập (tối đa 2,000 ký tự)"
            :disabled="mode=='edit'"
          />
        </div>

      </div>

      <div class="mt-2" style="width: 90%; margin-left: 1%;">
        <label class="txt-right required">Mô tả</label>
        <CkeditorCode v-model="content" :contentSet="content" @newdata="updateContent" />
        <input class="input_tmp_validator" id="content" />
      </div>

      <Toolbar class="fixed-bottom-toolbar col-lg-12">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DataServices from "@/core/DataServices";
import CkeditorCode from '@/views/admin/CkeditorCode.vue';
export default {
  components: {
    CkeditorCode,
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      reciever_type: [
        { value: 1, label: 'Tất cả người dùng' },
        { value: 2, label: 'Tất cả trang trại' },
        { value: 3, label: 'Người dùng' },
        { value: 4, label: 'Trang trại' }
      ],

      selectedRecieverType: null,
      farm: [],
      farmOptions: [],
      user: [],
      userOptions: [],
      title: "",
      short_content: "",
      content: "",
      spans: [],
    };
  },
  async mounted() {
    // console.log("this.model", this.model);
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.$commonFuction.is_loading(true);
      try {
        this.selectedRecieverType = this.reciever_type.find(
          (item) => item.value == this.model.reciever_type
        );
        if (this.model.notification_farm.length) {
          this.farm = this.model.notification_farm.map((farm) => ({
            value: farm.farm.id,
            name: farm.farm.name,
          }));
        }
        if (this.model.recievers.length) {
          this.user = this.model.recievers.map((user) => ({
            id: user.user.id,
            fullname: user.user.fullname,
            farm_id: user.user.farm_id,
          }));
        }
        this.title = this.model.title;
        this.short_content = this.model.short_content;
        this.content = this.model.content;
        this.updateContent([this.model.content]);
        // console.log("this.content", this.content);
        this.$commonFuction.is_loading(false);
      } catch(err) {
        console.log("Errrr", err);
        this.$commonFuction.is_loading(false);
      }
      this.$commonFuction.is_loading(false);
    }
  },
  watch: {
    async "selectedRecieverType"() {
      //Get the interact with the reciever type
      if (this.selectedRecieverType.value == 1) {
        await this.getListUser();
        this.user = this.userOptions;
      
      } else if (this.selectedRecieverType.value == 2) {
        await this.getListFarm();
        this.farm = this.farmOptions;
      } else if (this.selectedRecieverType.value == 3) {
        await this.getListUser();

      } else if (this.selectedRecieverType.value == 4) {
        await this.getListFarm();
      }
      this.user = [];
      this.farm = [];
    },
    "user": {
      handler() {
        if (this.selectedRecieverType.value == 3 || this.selectedRecieverType.value == 4) {
          this.updateSpans();
        }
      },
      deep: true
      
    },
    "farm": {
      handler() {
        if (this.selectedRecieverType.value == 4) {
          this.updateSpans();
        }
        this.getListUser();
        this.removeUserSpan();
      },
      deep: true
    },
  },
  methods: {
    backToList() {
      this.$emit("back");
    },

    async getListFarm() {
      var gqLQueryList = DataServices.getList("farm", {"fields": "id, name"});
      var where ={
        active: {_eq: true}
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: {name: "asc"}
        }
      })
      var listData = resData.data["farm"];
      this.farmOptions = listData.map(farm => ({ value: farm.id, name: farm.name }));
    },

    async getListUser() {
      var gqLQueryList = DataServices.getList("users", { "fields": "id, fullname, farm_id" });
      var where = {
        active: { _eq: true }
      };
      if (this.farm.length > 0) {
        where = {
          ...where,
          farm_id: { _in: this.farm.map(farm => farm.value) }
        };
      }
      var resData = await this.$apollo.mutate({
        mutation: gqLQueryList,
        variables: {
          where_key: where,
          orderBy: { fullname: "asc" }
        }
      });
      var listData = resData.data["users"];
      this.userOptions = listData;
    },

    updateSpans() {
      this.spans = [
        ...this.user.map((item) => ({ name: item.fullname, type: 'user' })),
        ...this.farm.map((item) => ({ name: item.name, type: 'farm' })),
      ];
    },

    removeSpan(index, type) {
      if (type === 'user') {
        this.user = this.user.filter((item, idx) => idx !== index);
        if (this.selectedRecieverType.value == 1) {
          this.selectedRecieverType = this.reciever_type.find(item => item.value == 3);
        }
      } else if (type === 'farm') {
        this.farm = this.farm.filter((item, idx) => idx !== index);
        if (this.selectedRecieverType.value == 2) {
          this.selectedRecieverType = this.reciever_type.find(item => item.value == 4);
        }
      }
      this.updateSpans();
    },

    //Remove user that is not in selected farm
    async removeUserSpan() {
      let deleteUsers = [];
      for (let i = 0; i < this.user.length; i++) {
        let user = this.user[i];
        let isExist = this.farm.find(farm => farm.value == user.farm_id);
        if (!isExist) {
          deleteUsers.push(i);
        }
      }
      for (let y = deleteUsers.length - 1; y >= 0; y--) {
        this.removeSpan(deleteUsers[y], 'user');
      }
    },

    async validateData() {
      this.validationErrors = {};

      let reciever_type_add = document.getElementById("reciever_type_add");
      if (
        this.selectedRecieverType == undefined ||
        this.selectedRecieverType == null
      ) {
        reciever_type_add.setCustomValidity("Gửi đến không được để trống!");
      } else {
        reciever_type_add.setCustomValidity("");
      }

      if (this.selectedRecieverType && (this.selectedRecieverType.value == 2 || this.selectedRecieverType.value == 4)) {
        let farm_add = document.getElementById("farm");
        if (this.farm.length <= 0) {
          farm_add.setCustomValidity("Chọn trang trại không được để trống!");
        } else {
          farm_add.setCustomValidity("");
        }
      }
      
      let user_add = document.getElementById("user");
      if (this.user.length <= 0) {
        user_add.setCustomValidity("Chọn người không được để trống!");
      } else {
        user_add.setCustomValidity("");
      }

      let title_add = document.getElementById("title_add");
      if (
        this.title == undefined ||
        this.title == null ||
        this.title == ""
      ) {
        title_add.setCustomValidity("Tiêu đề không được để trống!");
      } else if (this.title.length > 255) {
        title_add.setCustomValidity("Tiêu đề không được quá 255 ký tự!");
      } else {
        title_add.setCustomValidity("");
      }

      let short_content_add = document.getElementById("short_content");
      if (
        this.short_content == undefined ||
        this.short_content == null ||
        this.short_content == ""
      ) {
        short_content_add.setCustomValidity("Mô tả ngắn không được để trống!");
      } else {
        short_content_add.setCustomValidity("");
      }

      let content_add = document.getElementById("content");
      if (this.content == undefined || this.content == null || this.content == "") {
        content_add.setCustomValidity("Mô tả không được để trống!");
      } else {
        content_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },

    updateContent(newContent) {
      this.content = newContent[0];
    },

    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }
      var params = {
        reciever_type: this.selectedRecieverType.value.toString(),
        farm: this.farm.map(farm => farm.value),
        user: this.user.map(user => user.id),
        title: this.title,
        short_content: this.short_content,
        content: this.content,
      };
      // console.log("saveData", params);
      this.$emit("save", params);
      // }
    },

  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 480px;
  height: 270px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-multiselect-panel .p-checkbox.p-component {
  display: none !important;
}
.cus-tags{
  border-radius: 10px;
  padding: 8px;
  margin-right: 8px;
  background-color:#F2F3F7;
}
.cs-tag {
  padding: 10px 12px 10px 0px;
  font-weight: normal;
}
.cs-icon {
  color : #666666;
  padding-right: 4px;
  cursor: pointer;
}
.cs-icon-right {
  cursor: pointer;
}
</style>
